<template>
  <div style="padding: 0px" class="sub-view">
    <div class="box-table">
      <table>
        <!-- judul tabel  -->
        <tr>
          <th>Tanggal</th>
          <th>Cabang</th>
          <th>Waktu</th>
          <th>Tipe</th>
          <th>Lampiran</th>
          <th style="width: 20%">HR Review</th>
        </tr>
        <!-- start iterasi tabel -->
        <tr :key="index" v-for="(presensi, index) in rekapPresensi">
          <!-- Tanggal  -->
          <td>{{ toDate(presensi.waktuPengajuan) }}</td>
          <!-- Cabang  -->
          <td>
            {{ userData.penempatan }} <br />
            <!-- Full (07:30-17:00) -->
          </td>
          <!-- waktu presensi untuk tipe presensi  -->
          <td v-if="presensi.tipe === 'presensi'">
            Mulai:
            <span class="red-text">{{
              toClock(presensi.masukTime.seconds)
            }}</span>
            <br />
            Akhir:
            <span v-if="presensi.keluarTime" class="red-text">{{
              toClock(presensi.keluarTime.seconds)
            }}</span>
            <span v-else class="red-text">-</span>
          </td>

          <!-- waktu presensi untuk tipe absen dan cuti  -->
          <td v-else>
            Mulai:
            <span class="red-text">{{ presensi.tanggalMulai }}</span>
            <br />
            Akhir:
            <span class="red-text">{{ presensi.tanggalAkhir }}</span>
          </td>
          <!-- tipe presensi  -->
          <td v-if="presensi.tipe === 'absensi'" class="tipe-absen">
            <span>Absen</span>
          </td>
          <td v-else-if="presensi.tipe === 'cuti'" class="tipe-cuti">
            <span>Cuti</span>
          </td>
          <td v-else class="tipe-presensi"><span>Presensi</span></td>
          <!-- lampiran presensi -->
          <td v-if="presensi.tipe === 'presensi'" class="tabel-lampiran">
            <!-- lampiran masuk  -->
            <p
              @click="
                openCloseModal(
                  true,
                  presensi.masukPictureUrl[0],
                  presensi.masukLocation
                )
              "
            >
              <span>Masuk</span>
            </p>
            <!-- lampiran keluar  -->
            <p
              @click="
                openCloseModal(
                  true,
                  presensi.keluarPictureUrl[0],
                  presensi.keluarLocation
                )
              "
              v-if="presensi.keluarTime"
            >
              <span>Akhir</span>
            </p>

            <p style="color: #a0a3bd" v-else>
              <span>Akhir</span>
            </p>
          </td>
          <!-- lampiran absen dan cuti -->
          <td v-else class="tabel-lampiran">
            <p @click="openCloseModalKeterangan(true, presensi.keterangan)">
              <span>Keterangan</span>
            </p>
            <p @click="openCloseModalViewer(true, presensi.lampiranUrl[0])">
              <span>Dokumen</span>
            </p>
          </td>

          <!-- hasil review HR -->
          <td v-if="presensi.status === 'rejected'" class="hasil-review-tolak">
            <p class="detail-review">
              <span>TOLAK</span> {{ toClock(presensi.reviewTimestamp.seconds) }}
            </p>
            <p>oleh {{ presensi.reviewer }}</p>
          </td>

          <td
            v-else-if="presensi.status === 'accepted'"
            class="hasil-review-acc"
          >
            <p class="detail-review">
              <span>ACC</span> {{ toClock(presensi.reviewTimestamp.seconds) }}
            </p>
            <p>oleh {{ presensi.reviewer }}</p>
          </td>

          <td v-else class="hasil-review-proses">
            <p class="detail-review"><span>PENDING</span></p>
          </td>
        </tr>
        <!-- end iterasi tabel -->
      </table>
      <p
        v-if="!rekapPresensi || rekapPresensi.length === 0"
        class="empty-state-table"
      >
        Belum ada data
      </p>
    </div>

    <!-- modal untuk liat lokasi dan foto -->
    <div v-if="modalIsOpen" class="modal-backdrop">
      <div style="width: 445px; height: 458px" class="modal">
        <div class="content">
          <div style="text-align: center" class="text-modal">
            <h2 class="primary-text">
              Lokasi Presensi Masuk
              <svg
                style="margin-left: 8px; cursor: pointer"
                @click="openGmap"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.2866 7.71415V11.9999C11.2866 12.3787 11.136 12.7421 10.8681 13.01C10.6002 13.2779 10.2369 13.4284 9.85798 13.4284H2.00084C1.62196 13.4284 1.25859 13.2779 0.990684 13.01C0.722775 12.7421 0.572266 12.3787 0.572266 11.9999V4.14272C0.572266 3.76384 0.722775 3.40047 0.990684 3.13257C1.25859 2.86466 1.62196 2.71415 2.00084 2.71415H6.28655M9.14369 0.571289H13.4294M13.4294 0.571289V4.857M13.4294 0.571289L5.57227 8.42843"
                  stroke="#FFB700"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </h2>
            <h3 style="font-size: 14px; font-weight: 400; margin-top: 10px">
              {{ dataModal.namaLokasi }}
            </h3>
            <img
              style="width: 160px; height: 220px; object-fit: cover"
              :src="dataModal.urlGambar"
              alt=""
              srcset=""
            />
          </div>
        </div>
        <!-- close button -->
        <svg
          style="margin-right: -374px; margin-top: -379px"
          @click="openCloseModal(false)"
          class="close-button"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
            stroke="#1D1D1D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <!-- end of close button -->
      </div>
    </div>
    <!-- end of modal untuk liat lokasi dan foto -->

    <!-- modal untuk keterangan -->
    <div v-if="modalKeteranganIsOpen" class="modal-backdrop">
      <div style="width: 445px; height: 220px" class="modal">
        <div class="content">
          <div style="text-align: center" class="text-modal">
            <h2 class="primary-text">Keterangan</h2>
            <p style="font-size: 14px; font-weight: 400; margin-top: 10px">
              {{ keterangan }}
            </p>
          </div>
        </div>
        <!-- close button -->
        <svg
          style="margin-right: -374px; margin-top: -162px"
          @click="openCloseModalKeterangan(false)"
          class="close-button"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
            stroke="#1D1D1D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <!-- end of close button -->
      </div>
    </div>
    <!-- end of modal untuk keterangan -->

    <!-- modal view lampiran -->
    <ModalViewer v-if="modalViewerIsOpen">
      <div style="text-align: center" class="modal-content-viewer">
        <object
          style="object-fit: cover; margin: 10px 0px"
          :data="urlLampiran"
          width="750"
          height="390"
        ></object>

        <button
          @click="openDokumen"
          style="margin-top: 10px"
          class="yellow-button"
        >
          Buka dokumen
        </button>
      </div>
      <!-- close button -->
      <svg
        @click="openCloseModalViewer(false)"
        style="margin-top: -438px; margin-left: 340px"
        class="close-button"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
          stroke="#1D1D1D"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <!-- end of close button -->
    </ModalViewer>
    <!-- end of modal view lampiran -->
  </div>
</template>

<script>
import * as soluhaApi from "@/soluhaApi";
import * as soluhafire from "@/soluhafire";
import { mapState } from "vuex";
import { gmapApi } from "vue2-google-maps";
import ModalViewer from "@/components/modal/RelativeModal";

export default {
  components: {
    ModalViewer,
  },

  data() {
    return {
      modalIsOpen: false,
      modalKeteranganIsOpen: false,
      modalViewerIsOpen: false,
      // yang akan diambil dari api
      riwayatPresensi: null,
      // data untuk modal lokasi
      dataModal: {
        urlGambar: "",
        urlLokasi: "",
        namaLokasi: "",
      },
      // data modal keterangan
      keterangan: "",
      // data modal view
      urlLampiran: "",
    };
  },

  methods: {
    openCloseModal(isOpen, picture, location) {
      if (isOpen) {
        this.geocoding(location);
        this.modalIsOpen = true;
        this.dataModal.urlGambar = picture;
        this.dataModal.urlLokasi = `https://maps.google.com/?q=${location.latitude},${location.longitude}`;
      } else this.modalIsOpen = false;
    },

    openCloseModalKeterangan(isOpen, keterangan) {
      if (isOpen) {
        this.keterangan = keterangan;
        this.modalKeteranganIsOpen = true;
      } else {
        this.keterangan = "";
        this.modalKeteranganIsOpen = false;
      }
    },

    openCloseModalViewer(isOpen, url) {
      if (isOpen) {
        this.urlLampiran = url;
        this.modalViewerIsOpen = true;
      } else {
        this.urlLampiran = "";
        this.modalViewerIsOpen = false;
      }
    },

    async geocoding(location) {
      let lokasi = {
        lat: location.latitude,
        lng: location.longitude,
      };
      await this.$gmapApiPromiseLazy();
      // reverse geocode
      let geocoder = new this.google.maps.Geocoder();
      let alamat;
      // ada 8 hasil geocode, yang [0] paling lengkap :)
      geocoder.geocode({ location: lokasi }, (result, status) => {
        if (status !== "OK") return;
        if (!result[0]) return;

        alamat = `${result[0].address_components[0].long_name} ${result[0].address_components[2].long_name} ${result[0].address_components[3].long_name}`;
        alamat = alamat.toUpperCase();
        this.dataModal.namaLokasi = alamat;
      });
    },

    openGmap() {
      window.open(this.dataModal.urlLokasi, "_blank");
    },

    toClock(time) {
      return soluhafire.epochToClock(time);
    },

    toDate(time) {
      return soluhaApi.epochToDate(time);
    },

    openDokumen() {
      window.open(this.urlLampiran, "_blank");
    },
  },

  computed: {
    ...mapState(["userData"]),
    rekapPresensi() {
      let rekapPresensi = [
        ...this.userData.riwayatPresensi,
        ...this.userData.riwayatAbsen,
        ...this.userData.riwayatCuti,
      ];
      // sorting berdasarkan waktu pengajuan
      rekapPresensi.sort((a, b) => b.waktuPengajuan - a.waktuPengajuan);
      return rekapPresensi;
    },
    google: gmapApi,
  },
};
</script>

<style scoped>
@import url("../../assets/css/hrd/riwayat.css");
</style>
